import { useState } from 'react'
import { useSelector } from 'react-redux'
import { Element } from '../../../../common/html/element'
import { Icon } from '../../../../common/html/icon'
import { EditName } from '../common/EditName'
import { selectSelectedCriteria } from '../store/slice'

export const CriteriaName = () => {
  const selectedCriteria = useSelector(selectSelectedCriteria())

  const [isEdit, setIsEdit] = useState(false)

  const openEdit = () => {
    setIsEdit(true)
  }

  const closeEdit = () => {
    setIsEdit(false)
  }

  return isEdit ? (
    <EditName
      name={selectedCriteria.screeningSavedCriteriaName}
      closeEdit={closeEdit}
      inputStyle={{ fontSize: 14 }}
    />
  ) : (
    <Element className="flex1 minW0 dFlex alignItemsCenter gap1">
      <Element className="fw600 breakWord" style={{ fontSize: 14 }}>
        {selectedCriteria.screeningSavedCriteriaName}
      </Element>
      <Icon
        className="icon-edit-fill"
        style={{ fontSize: 15, color: '#D5D5D5' }}
        onClick={openEdit}
      />
    </Element>
  )
}
